
import { Component, Prop, Vue } from 'vue-property-decorator';
import UIUtil from '@/utils/ui.util';
import CustomIcon from '@/components/CustomIcon.vue';
import GradientExternalLinkIcon from '@/components/icons/GradientExternalLinkIcon.vue';
import BlockedIcon from '@/components/icons/BlockedIcon.vue';

export interface ISectionCardData {
  link: string;
  title?: string;
  text?: string;
  customColors?: string[];
  fixedHeight?: number;
  externalLink?: boolean;
  blocked?: boolean;
  isNew?: boolean;
  tagActive?: boolean;
  tagText?: string;
}

@Component({
  components: {
    CustomIcon,
    GradientExternalLinkIcon,
    BlockedIcon,
  },
})
export default class SectionKpiCard extends Vue {
  @Prop([String, Array]) private title?: string | string[];
  @Prop(String) text?: string;
  @Prop(String) link!: string;
  @Prop(Array) customColors?: string[];
  @Prop(Number) private fixedHeight?: number;
  @Prop(Number) private fixedWidth?: number;
  @Prop({ default: false }) externalLink!: boolean;
  @Prop({ default: false }) blocked!: boolean;
  @Prop({ default: false }) isNew!: boolean;
  @Prop({ default: false }) tagActive!: boolean;
  @Prop(String) tagText?: string;

  isHovered = false;
  idSuffixGradientIcon: string = Math.random().toString(36).slice(2, 10);

  get cardSize(): string {
    return this.fixedHeight ? `${this.fixedHeight}px` : 'auto';
  }

  get cardTitle(): string {
    if (!this.title) return '';
    return Array.isArray(this.title) ? this.title.join(' ') : this.title;
  }

  get cardSubtitles(): string[] {
    return Array.isArray(this.title) ? this.title.slice(1) : [];
  }

  generateSrc(fileName: string): string {
    return UIUtil.generateImagePathbyFileName(fileName);
  }

  generateGradient(colorArray: string[]): string {
    return UIUtil.generateGradient(colorArray);
  }

  goToLink(link: string, blocked = false, externalLink = false): void {
    if (blocked) return;
    if (externalLink) {
      window.open(link, '_blank');
    } else {
      this.$router.push(link);
    }
  }
}
